import $ from "jquery";
import globals from "../globals";
import { readAPIErrorMessage } from "../helper/api_helper";

export function getRecommendations(hashtag_name, userName, page) {
  var url = globals.baseAPI + "hashtags/" + hashtag_name + "?page=" + page;
  if (userName) {
    url =
      globals.baseAPI +
      "users/" +
      userName +
      "/hashtags/" +
      hashtag_name +
      "?page=" +
      page;
  }

  let hasCanceled_ = false;
  var ajaxCall = null;
  const wrappedPromise = new Promise((resolve, reject) => {
    ajaxCall = $.get(url, function(res) {
      if (!hasCanceled_) {
        resolve({
          recommendations: res.recommendations,
          loaded: true,
          total_pages: res.total_pages,
          errors: ""
        });
      }
    }).fail(function(err) {
      if (!hasCanceled_) {
        reject({
          recommendations: [],
          loaded: true,
          total_pages: 0,
          errors: readAPIErrorMessage(err)
        });
      }
    });
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
      ajaxCall.abort();
    }
  };
}



// WEBPACK FOOTER //
// ./src/helper/hashtag_helper.jsx